import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-af719722"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "target" }
const _hoisted_2 = { class: "container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_typography_title = _resolveComponent("a-typography-title")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_typography = _resolveComponent("a-typography")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_a_typography, null, {
        default: _withCtx(() => [
          _createVNode(_component_a_typography_title, { level: 1 }, {
            default: _withCtx(() => [
              _createTextVNode(" 体验CostPilot，轻松达成云成本优化目标！ ")
            ]),
            _: 1 /* STABLE */
          }),
          _createVNode(_component_a_space, {
            size: _ctx.$Store.Public().isGridMatch('>=',_ctx.$Enum.GridEnum.XL)?'large':'small'
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_button, {
                type: "link",
                class: "button_1",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$RQ.GoGSS()))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" 免费体验 ")
                ]),
                _: 1 /* STABLE */
              }),
              _createVNode(_component_a_button, {
                type: "link",
                class: "button_1",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$Store.Page().openModal('modalFormCollection','demo')))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" 预约咨询 ")
                ]),
                _: 1 /* STABLE */
              })
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["size"])
        ]),
        _: 1 /* STABLE */
      })
    ])
  ]))
}